import { TurnstileErrors } from '../common/CommonEnums';

const initialState = {
    isAuthenticated: null,
    errorMessage: null,
    loading: false,
    loginType: "",
    filePathURL: "",
    isLoadingCaptcha: false,
    captchaImage:""
}
const LoginReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case 'LOGIN_REQUEST':
            return Object.assign({}, state, { errorMessage: null,loading: true });
        case 'SET_LOGIN_SUCCESS':
            return Object.assign({}, state, { isAuthenticated: true, errorMessage: null, loading: false, loginType: action.loginSuccess.loginType, filePathURL: action.loginSuccess.filePathURL});
        case 'SET_LOGIN_FAILURE':
            return Object.assign({}, state, { isAuthenticated: false, errorMessage: action.loginError.errorMessage, loading: false });
        case 'LOGOUT_REQUEST':
            return Object.assign({}, state, action.logout);
        case 'LOGOUT_SUCCESS':
            return Object.assign({}, state, { isAuthenticated: false, errorMessage: null });
        case 'RESET_TURNSTILE_RETRY_COUNT':
            return Object.assign({}, state, { turnstileRetryCount: TurnstileErrors.DefaultTurnstileRetryCount });
        case 'REFRESH_TEXT_CAPTCHA_REQUEST':
            return Object.assign({}, state, { isLoadingCaptcha: true });
        case 'REFRESH_TEXT_CAPTCHA_SUCCESS':
            return Object.assign({}, state, { isLoadingCaptcha: false, captchaImage: action.captchaImage });
        case 'REFRESH_TEXT_CAPTCHA_FAILURE':
            return Object.assign({}, state, action.error, { isLoadingCaptcha: false });
        default:
            return state;
    }
}
export default LoginReducer;